// src/lib/marketing/metricConfig.ts
const fmt = (v: number) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v);
const fmtNum = (v: number) => v.toLocaleString('pt-BR');

export type MetricKey = 'spend' | 'impressions' | 'link_clicks' | 'results_total' | 'cost_per_result';

export const METRIC_CONFIG: Record<MetricKey, {
  label: string; color: string; axis: 'left' | 'right';
  formatFn: (v: number) => string; defaultOn: boolean;
}> = {
  spend:           { label: 'Gasto (R$)',           color: '#5F6C37', axis: 'left',  formatFn: fmt,    defaultOn: true  },
  results_total:   { label: 'Resultados',           color: '#3b82f6', axis: 'right', formatFn: fmtNum, defaultOn: true  },
  cost_per_result: { label: 'Custo/Resultado (R$)', color: '#ec4899', axis: 'left',  formatFn: fmt,    defaultOn: false },
  link_clicks:     { label: 'Cliques no Link',      color: '#f59e0b', axis: 'right', formatFn: fmtNum, defaultOn: false },
  impressions:     { label: 'Impressões',           color: '#6366f1', axis: 'right', formatFn: fmtNum, defaultOn: false },
};

export const METRIC_KEYS = Object.keys(METRIC_CONFIG) as MetricKey[];
